module.exports = __webpack_public_path__ + "static/media/GothamRnd-Book.c7a25c1a.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./src/fonts/GothamRnd-Book.eot
 ** module id = 1347
 ** module chunks = 0
 **/